import React, { useEffect, useState } from "react";
import Button from "../../extra/Button";
import { CLOSE_DIALOGUE } from "../../store/dialogue/dialogue.type";
import Input from "../../extra/Input";
import { connect, useDispatch, useSelector } from "react-redux";
import {
  createGift,
  updateGift,
} from "../../store/gift/gift.action";

const GiftDialog = (props) => {
  const { dialogueData } = useSelector((state) => state.dialogue);
  const [mongoId, setMongoId] = useState(0);
  const [name, setName] = useState("");
  const [price, setPrice] = useState("");
  const [category, setCategory] = useState("hearts");
  const [rarity, setRarity] = useState("common");
  const [animationType, setAnimationType] = useState("simple");
  const [animationUrl, setAnimationUrl] = useState("");
  const [order, setOrder] = useState(0);
  const [isActive, setIsActive] = useState(true);
  const [icon, setIcon] = useState(null);
  const [iconPath, setIconPath] = useState("");
  const [error, setError] = useState({
    name: "",
    price: "",
    icon: "",
  });
  const dispatch = useDispatch();

  useEffect(() => {
    setMongoId(dialogueData?._id);
    setName(dialogueData?.name || "");
    setPrice(dialogueData?.price || "");
    setCategory(dialogueData?.category || "hearts");
    setRarity(dialogueData?.rarity || "common");
    setAnimationType(dialogueData?.animationType || "simple");
    setAnimationUrl(dialogueData?.animationUrl || "");
    setOrder(dialogueData?.order || 0);
    setIsActive(dialogueData?.isActive !== undefined ? dialogueData?.isActive : true);
    setIconPath(dialogueData?.icon);
  }, [dialogueData]);

  const handleIcon = (e) => {
    setError((prevErrors) => ({
      ...prevErrors,
      icon: "",
    }));
    setIcon(e.target.files[0]);
    setIconPath(URL.createObjectURL(e.target.files[0]));
  };

  const handleSubmit = () => {
    if (!name || !price || !iconPath) {
      let error = {};
      if (!name) error.name = "Name is required!";
      if (!price) error.price = "Price is required!";
      if (!iconPath) error.icon = "Icon is required!";

      return setError({ ...error });
    } else {
      const formData = new FormData();
      formData.append("name", name);
      formData.append("price", price);
      formData.append("category", category);
      formData.append("rarity", rarity);
      formData.append("animationType", animationType);
      formData.append("animationUrl", animationUrl);
      formData.append("order", order);
      formData.append("isActive", isActive);
      if (icon) {
        formData.append("icon", icon);
      }

      if (mongoId) {
        dispatch(updateGift(formData, mongoId));
      } else {
        dispatch(createGift(formData));
      }
      dispatch({ type: CLOSE_DIALOGUE });
    }
  };

  return (
    <div className="mainDialogue fade-in">
      <div className="Dialogue" style={{ maxWidth: "600px" }}>
        <div className="dialogueHeader">
          <div className="headerTitle fw-bold text-white">Gift</div>
          <div
            className="closeBtn "
            onClick={() => {
              dispatch({ type: CLOSE_DIALOGUE });
            }}
          >
            <i className="fa-solid fa-xmark"></i>
          </div>
        </div>
        <div className="dialogueMain" style={{ maxHeight: "70vh", overflowY: "auto" }}>
          <div className="row">
            <div className="col-12">
              <Input
                label={`Icon`}
                id={`icon`}
                type={`file`}
                accept={`image/*`}
                errorMessage={error.icon && error.icon}
                onChange={(e) => handleIcon(e)}
              />
              {iconPath && (
                <div className="image-start">
                  <img
                    src={iconPath}
                    alt="gift"
                    draggable="false"
                    width={80}
                    height={80}
                    className="m-0"
                    style={{ borderRadius: "8px", objectFit: "cover" }}
                  />
                </div>
              )}
            </div>
            <div className="col-12">
              <Input
                label={`Gift Name`}
                id={`name`}
                type={`text`}
                value={name}
                placeholder={`Enter gift name`}
                errorMessage={error.name && error.name}
                onChange={(e) => {
                  setName(e.target.value);
                  if (!e.target.value) {
                    return setError({
                      ...error,
                      name: `Name is required`,
                    });
                  } else {
                    return setError({
                      ...error,
                      name: "",
                    });
                  }
                }}
              />
            </div>
            <div className="col-12">
              <Input
                label={`Price (Coins)`}
                id={`price`}
                type={`number`}
                value={price}
                placeholder={`Enter price in coins`}
                errorMessage={error.price && error.price}
                onChange={(e) => {
                  setPrice(e.target.value);
                  if (!e.target.value) {
                    return setError({
                      ...error,
                      price: `Price is required`,
                    });
                  } else {
                    return setError({
                      ...error,
                      price: "",
                    });
                  }
                }}
              />
            </div>
            <div className="col-md-6">
              <label className="text-white mb-2">Category</label>
              <select
                className="form-control"
                value={category}
                onChange={(e) => setCategory(e.target.value)}
                style={{
                  backgroundColor: "#2d2d2d",
                  color: "white",
                  border: "1px solid #444",
                  padding: "10px"
                }}
              >
                <option value="hearts">Hearts</option>
                <option value="flowers">Flowers</option>
                <option value="luxury">Luxury</option>
                <option value="special">Special</option>
                <option value="trending">Trending</option>
              </select>
            </div>
            <div className="col-md-6">
              <label className="text-white mb-2">Rarity</label>
              <select
                className="form-control"
                value={rarity}
                onChange={(e) => setRarity(e.target.value)}
                style={{
                  backgroundColor: "#2d2d2d",
                  color: "white",
                  border: "1px solid #444",
                  padding: "10px"
                }}
              >
                <option value="common">Common</option>
                <option value="rare">Rare</option>
                <option value="epic">Epic</option>
                <option value="legendary">Legendary</option>
              </select>
            </div>
            <div className="col-12 mt-3">
              <label className="text-white mb-2">Animation Type</label>
              <select
                className="form-control"
                value={animationType}
                onChange={(e) => setAnimationType(e.target.value)}
                style={{
                  backgroundColor: "#2d2d2d",
                  color: "white",
                  border: "1px solid #444",
                  padding: "10px"
                }}
              >
                <option value="simple">Simple</option>
                <option value="animated">Animated</option>
                <option value="full-screen">Full Screen</option>
              </select>
            </div>
            <div className="col-12">
              <Input
                label={`Animation URL (Optional)`}
                id={`animationUrl`}
                type={`text`}
                value={animationUrl}
                placeholder={`Lottie/GIF URL`}
                onChange={(e) => setAnimationUrl(e.target.value)}
              />
            </div>
            <div className="col-12">
              <Input
                label={`Display Order`}
                id={`order`}
                type={`number`}
                value={order}
                placeholder={`Enter order number`}
                onChange={(e) => setOrder(parseInt(e.target.value) || 0)}
              />
            </div>
            <div className="col-12">
              <div className="form-check" style={{ marginTop: "10px" }}>
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="isActive"
                  checked={isActive}
                  onChange={(e) => setIsActive(e.target.checked)}
                  style={{ cursor: "pointer" }}
                />
                <label
                  className="form-check-label text-white"
                  htmlFor="isActive"
                  style={{ cursor: "pointer" }}
                >
                  Active
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="dialogueFooter">
          <div className="dialogueBtn">
            {!mongoId ? (
              <>
                <Button
                  btnName={`Submit`}
                  btnColor={`btnBlackPrime text-light`}
                  style={{ borderRadius: "5px", width: "80px" }}
                  newClass={`me-2`}
                  onClick={handleSubmit}
                />
              </>
            ) : (
              <>
                <Button
                  btnName={`Update`}
                  btnColor={`btnBlackPrime text-light`}
                  style={{ borderRadius: "5px", width: "80px" }}
                  newClass={`me-2`}
                  onClick={handleSubmit}
                />
              </>
            )}
            <Button
              btnName={`Close`}
              btnColor="myCustomButton"
              style={{ borderRadius: "5px", width: "80px" }}
              onClick={() => {
                dispatch({ type: CLOSE_DIALOGUE });
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default connect(null, { createGift, updateGift })(
  GiftDialog
);
